import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';

// Saisie du mobile de l'utilisateur (enregistré sur son compte, même champ que la page Mon compte)
@Component({
    selector: 'app-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.scss']
})
export class PhoneComponent {

    mobile = '';
    loading = false;
    error = '';

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        public dialogRef: MatDialogRef<PhoneComponent>) {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.loading) {
            return;
        }
        const mobile = (this.mobile || '').replace(/[\s.\-]/g, '');
        if (!/^(\+\d{6,15}|0\d{9})$/.test(mobile)) {
            this.error = 'Veuillez saisir un numéro de téléphone valide.';
            return;
        }
        this.error = '';
        this.loading = true;
        this.userService.saveMobile(this.mobile.trim()).subscribe(() => {
            this.loading = false;
            this.dialogRef.close(this.mobile.trim());
        }, error => {
            this.loading = false;
            this.alertService.error(typeof error === 'string' ? error : 'L\'enregistrement du numéro a échoué, veuillez réessayer.');
        });
    }
}
